export {};
//# sourceMappingURL=IThrottleMgr.js.map